export default __webpack_public_path__ + "static/media/layer8.5e694b31.svg";